import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { FaBars } from "react-icons/fa";
import { Link } from "react-router-dom";
import UserAccess from "components/User/Access";
import styles from "./index.module.css";
import LoLoLogo from "img/Logo.png";
import Flag from "react-world-flags";
import {
    UPDATE_APP_AUTH,
    UPDATE_APP_FORUMCATEGORYID,
    UPDATE_APP_LANG,
} from "views/App/constants";
import { useTranslation } from "react-i18next";
import {
    FORUM_CATEGORY_TYPE_ID,
    FORUM_CATEGORY_TYPE_ID_ca,
} from "../../constants";
import i18n from "../../app/i18n";
import KakaoLoginButton from "../Kakao";
import YouTube from "react-youtube";

const Header = ({ username, setToken, isSuperUser }) => {
    const dispatch = useDispatch();
    const location = useLocation();
    const history = useHistory();
    const [menuOpen, setMenuOpen] = useState(false);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const { t } = useTranslation();
    const lang = useSelector((state) => state.app.lang);
    let forumCategoryId =
        useSelector((state) => state.app.forumCategoryId) || 0;
    const [videoId, setYoutubeId] = useState("sy8mjGYgTVU");
    const [videoTitle, setYoutubeTitle] = useState("");
    const [videoText, setYoutubeText] = useState("");
    const [backgroundStyle, setBackgroundStyle] = useState({
        backgroundSize: "contain",
    });
    const [player, setPlayer] = useState(null);

    // Debug current lang state
    console.log(`[Header] Current Redux lang: ${lang || "undefined"}`);

    // 초기 언어 설정
    useEffect(() => {
        const storedLang = localStorage.getItem("selectedFlag");
        const initialLang = storedLang || lang || "ca"; // 기본값 'ca' (영어)

        // i18n 언어 설정
        if (i18n.language !== initialLang) {
            i18n.changeLanguage(initialLang); // i18n 언어 변경
        }

        // Redux 상태와 i18n 언어 동기화
        if (lang !== initialLang) {
            dispatch({
                type: UPDATE_APP_LANG,
                lang: initialLang,
            });
        }
    }, [lang, dispatch]);

    // URL의 언어 코드 변경 처리
    useEffect(() => {
        const matchedLang = location.pathname.match(/-(kr|ca|cn)$/i);
        if (matchedLang) {
            const urlLang = matchedLang[1].toLowerCase();
            if (urlLang !== lang) {
                localStorage.setItem("selectedFlag", urlLang);
                dispatch({
                    type: UPDATE_APP_LANG,
                    lang: urlLang,
                });
                i18n.changeLanguage(urlLang);
            }
        }
    }, [location.pathname, lang, dispatch]);

    // Handle browser back/forward navigation
    useEffect(() => {
        const handlePopState = () => {
            const storedLang = localStorage.getItem("selectedFlag") || "ca";
            console.log(
                `[Header] Browser navigation detected, restoring language: ${storedLang}`
            );

            dispatch({
                type: UPDATE_APP_LANG,
                lang: storedLang,
            });
            i18n.changeLanguage(storedLang);
        };

        window.addEventListener("popstate", handlePopState);
        return () => window.removeEventListener("popstate", handlePopState);
    }, [dispatch]);

    // Helper function to determine initial language from localStorage or browser
    const determineInitialLanguage = () => {
        // Check localStorage first
        const storedLang = localStorage.getItem("selectedFlag");

        // Then check browser language
        let browserLang = "ca"; // Default to English
        if (navigator.language.startsWith("ko")) {
            browserLang = "kr";
        } else if (navigator.language.startsWith("zh")) {
            browserLang = "cn";
        }

        // Return localStorage value if exists, otherwise browser language
        return storedLang || browserLang;
    };

    // Handle stored login data
    const handleStoredLoginData = () => {
        const storedLoginData = localStorage.getItem("loginData");
        const storedExpirationTime = localStorage.getItem(
            "loginDataExpiration"
        );

        if (storedLoginData && storedExpirationTime) {
            const { username, password, accessToken, isSuperUser, email } =
                JSON.parse(storedLoginData);
            const expirationTime = parseInt(storedExpirationTime, 10);

            if (expirationTime && expirationTime > new Date().getTime()) {
                dispatch({
                    type: UPDATE_APP_AUTH,
                    username,
                    password,
                    accessToken,
                    isSuperUser,
                    email,
                });
            } else {
                localStorage.removeItem("loginData");
                localStorage.removeItem("loginDataExpiration");
            }
        }
    };

    const isDynamicRoute = Object.keys(FORUM_CATEGORY_TYPE_ID_ca).some(
        (categoryId) => {
            const categoryPath = `/${FORUM_CATEGORY_TYPE_ID_ca[
                categoryId
            ].toLowerCase()}`;
            return location.pathname.toLowerCase() === categoryPath;
        }
    );

    const handleFlagClick = (countryCode) => {
        console.log(
            `[Header] handleFlagClick - Selected language: ${countryCode}`
        );

        // 언어가 선택되면 항상 언어를 업데이트 (localStorage, Redux, i18n)
        localStorage.setItem("selectedFlag", countryCode);
        dispatch({
            type: UPDATE_APP_LANG,
            lang: countryCode,
        });
        i18n.changeLanguage(countryCode);

        // 현재 URL에 언어 코드가 포함되어 있을 때만 URL을 업데이트
        const matchedLang = location.pathname.match(/-(kr|ca|cn)$/i);
        if (matchedLang) {
            const currentPath = location.pathname;
            const pathWithoutLang = currentPath.replace(/-(kr|ca|cn)$/, ""); // 기존 언어 코드 제거
            history.push(`${pathWithoutLang}-${countryCode}`);
        }

        // Close dropdown
        setDropdownOpen(false);
    };

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    };

    const updateForumCategoryId = (id, city) => {
        dispatch({
            type: UPDATE_APP_FORUMCATEGORYID,
            forumCategoryId: id,
        });

        // Don't add city or language to URL if city is "All"
        if (city === "All") {
            history.push("/");
        } else {
            // For other cities, just use the path directly without language code
            const path = city.toLowerCase();
            history.push(`/${path}`);
        }
    };

    const closeMobileMenu = () => {
        setMenuOpen(false);
    };

    const words =
        lang === "kr" ? FORUM_CATEGORY_TYPE_ID : FORUM_CATEGORY_TYPE_ID_ca;

    useEffect(() => {
        const route = location.pathname;
        let style = {
            backgroundSize: "cover",
            opacity: "rgba(248, 245, 247, 0.2)",
            backgroundColor: "#f0f0f0",
        };
        setYoutubeId("sy8mjGYgTVU");
        setYoutubeTitle(t("YoutubeHomeTitle"));
        setYoutubeText(t("YoutubeHomeText"));
        setBackgroundStyle(style);

        dispatch({
            type: UPDATE_APP_FORUMCATEGORYID,
            forumCategoryId,
        });
    }, [location.pathname, forumCategoryId, lang, t]);

    const opts = {
        width: "100%",
        height: "100%",
        playerVars: {
            autoplay: 1,
            controls: 0,
            loop: 1,
            showinfo: 0,
            mute: 1,
            modestbranding: 1,
            disablekb: 1,
        },
    };

    const onReady = (event) => {
        setPlayer(event.target);
    };

    const onEnd = () => {
        if (player) {
            player.seekTo(0);
        }
    };

    const languageOptions = [
        { code: "kr", name: "한국어", flagHeight: 14 },
        { code: "ca", name: "English", flagHeight: 12 },
        { code: "cn", name: "中文", flagHeight: 14 },
    ];

    // Helper function to create clean paths without language
    const getCleanPath = (basePath) => {
        return `/${basePath}`;
    };

    // Determine which language is currently selected
    const selectedFlag = lang || localStorage.getItem("selectedFlag") || "ca";

    return (
        <>
            <div className={styles.background}>
                <nav className={styles.headerContainer}>
                    <div className={styles.logoLink}>
                        <img
                            src={LoLoLogo}
                            className={styles.logoImg}
                            alt="Home"
                            onClick={() => updateForumCategoryId(0, "All")}
                        />
                        <div
                            className={styles.LogoTxt}
                            onClick={() => updateForumCategoryId(0, "All")}
                        >
                            {t("Logo")}
                        </div>
                        <span className={styles.kakaoLink}>
                            <KakaoLoginButton />
                        </span>
                    </div>
                    <div className={styles.flagLink}>
                        <div
                            className={styles.langSelect}
                            onClick={toggleDropdown}
                        >
                            <span>
                                <Flag
                                    code={selectedFlag}
                                    height={
                                        languageOptions.find(
                                            (opt) => opt.code === selectedFlag
                                        )?.flagHeight || 16
                                    }
                                    style={
                                        selectedFlag === "ca"
                                            ? { border: "1px solid white" }
                                            : {}
                                    }
                                />{" "}
                                {languageOptions.find(
                                    (opt) => opt.code === selectedFlag
                                )?.name || "English"}
                            </span>
                            <span className={styles.dropdownArrow}>▼</span>
                        </div>
                        {dropdownOpen && (
                            <div className={styles.dropdownMenu}>
                                {languageOptions.map((option) => (
                                    <div
                                        key={option.code}
                                        className={styles.dropdownItem}
                                        onClick={() =>
                                            handleFlagClick(option.code)
                                        }
                                    >
                                        <Flag
                                            code={option.code}
                                            height={option.flagHeight}
                                            style={
                                                option.code === "ca"
                                                    ? {
                                                          border: "1px solid white",
                                                      }
                                                    : {}
                                            }
                                        />{" "}
                                        {option.name}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                    <div
                        id="mobileMenu"
                        className={
                            menuOpen ? styles.mobileMenu : styles.desktopMenu
                        }
                    >
                        <span className={styles.leftBar}> </span>
                        <Link
                            key={lang}
                            className={styles.ceoLink}
                            to={getCleanPath("career")}
                            onClick={closeMobileMenu}
                        >
                            {t("Hire")}
                        </Link>
                        <span className={styles.leftBar}> </span>
                        <Link
                            className={styles.ceoLink}
                            to={getCleanPath("contact")}
                            onClick={closeMobileMenu}
                        >
                            {t("ContactUs")}
                        </Link>
                        <span className={styles.leftBar}> </span>
                        <Link
                            className={styles.ceoLink}
                            to={getCleanPath("ceo")}
                            onClick={closeMobileMenu}
                        >
                            {t("IntroCEO")}
                        </Link>
                        <UserAccess
                            username={username}
                            setToken={setToken}
                            isSuperUser={isSuperUser}
                            onCloseMobileMenu={closeMobileMenu}
                        />
                    </div>
                    <div className={styles.mobileMenuIcon} onClick={toggleMenu}>
                        <FaBars />
                    </div>
                </nav>
            </div>
            <div className={styles.youtubeWrap}>
                <YouTube
                    videoId={videoId}
                    className={styles.youtubeVideo}
                    opts={opts}
                    onReady={onReady}
                    onEnd={onEnd}
                />
                <div className={styles.youtubeText}>{videoTitle}</div>
                <div
                    className={styles.youtubeSubText}
                    dangerouslySetInnerHTML={{ __html: videoText }}
                ></div>
            </div>
        </>
    );
};

Header.defaultProps = {
    username: "visitor",
    address: "./",
    accessToken: "",
    isSuperUser: false,
};

export default Header;
